import { bindable, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { PortalTemplateTypes } from '../../services/template-service';

@autoinject
export class PaymentHistoryReceiptPage {
	PNRef: number;
	receiptType: PortalTemplateTypes;
	customerAccountNumber: string;
	bucketKey: number;

	constructor(private router: Router) {

	}

	activate(params, routeData) {
		if (!routeData.payment) {
			this.back();
			return;
		}

		this.PNRef = routeData.payment.PNRef;
		this.receiptType = this.getReceiptType(routeData.payment.transactionType);
		this.customerAccountNumber = routeData.payment.accountName;
		this.bucketKey = routeData.payment.bucketKey;
	}

	// TODO: make this use something other than a string compare
	getReceiptType(type: string): PortalTemplateTypes {
		let template = PortalTemplateTypes.CreditCardSinglePaymentReceipt;
		if (type.toUpperCase().includes('CARD')) {
			template = PortalTemplateTypes.CreditCardSinglePaymentReceipt;
		} else if (type.toUpperCase().includes('ACH')) {
			template = PortalTemplateTypes.CheckSinglePaymentReceipt;
		}
		return template;
	}

	back() {
		this.router.navigateBack();
	}

}
